import { useEffect, useState } from 'react';
import { X, ExternalLink } from 'lucide-react';

const fetchBlob = async (id) => {
  const res = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/attachments/${id}/download`, { credentials: 'include' });
  if (!res.ok) throw new Error('Load failed');
  return URL.createObjectURL(await res.blob());
};

// Small inline image thumbnail for images
export function AttachmentThumb({ attachment }) {
  const [url, setUrl] = useState(null);
  useEffect(() => {
    let mounted = true; let created = null;
    fetchBlob(attachment.id).then((u) => { created = u; if (mounted) setUrl(u); }).catch(() => {});
    return () => { mounted = false; if (created) URL.revokeObjectURL(created); };
  }, [attachment.id]);
  if (!url) return <div className="thumb-placeholder">…</div>;
  return <img data-testid={`thumb-${attachment.id}`} className="thumb" src={url} alt={attachment.original_filename} />;
}

// Full-screen preview modal for images or PDFs
export function AttachmentPreviewModal({ attachment, onClose }) {
  const [url, setUrl] = useState(null);
  const [error, setError] = useState('');
  useEffect(() => {
    let mounted = true; let created = null;
    fetchBlob(attachment.id).then((u) => { created = u; if (mounted) setUrl(u); }).catch(() => setError('Could not load preview'));
    return () => { mounted = false; if (created) URL.revokeObjectURL(created); };
  }, [attachment.id]);

  const isImage = (attachment.content_type || '').startsWith('image/');
  const isPdf = attachment.content_type === 'application/pdf';

  return (
    <div className="drawer-overlay" onClick={onClose} data-testid="preview-modal">
      <div className="preview-box" onClick={(e) => e.stopPropagation()}>
        <div className="preview-head">
          <div>
            <strong>{attachment.original_filename}</strong>
            <small className="muted"> · {attachment.content_type}</small>
          </div>
          <div style={{ display: 'flex', gap: 8 }}>
            {url && <a className="icon-btn" href={url} target="_blank" rel="noreferrer" title="Open in new tab"><ExternalLink size={16} /></a>}
            <button className="icon-btn" data-testid="preview-close" onClick={onClose}><X size={18} /></button>
          </div>
        </div>
        <div className="preview-body">
          {error && <p className="error">{error}</p>}
          {!error && !url && <p className="muted">Loading…</p>}
          {url && isImage && <img data-testid="preview-image" src={url} alt={attachment.original_filename} />}
          {url && isPdf && <iframe data-testid="preview-pdf" title={attachment.original_filename} src={url} />}
          {url && !isImage && !isPdf && (
            <p className="muted">No inline preview for this file type. Use the download button instead.</p>
          )}
        </div>
      </div>
    </div>
  );
}
